import React, { useState, useEffect } from "react";
import { Button } from "@material-ui/core";
import { useTranslation } from "localization/translation";
import { CANCELED, CONFIRMED } from "Constants";
import { AcceptUserModal } from "../modals/acceptModal";
import * as Api from "service";
import useStore from "context";

export const AcceptRejectButtons = ({
  item,
  refresh = () => {},
  userId = null,
  userSection = false,
  setUserDetails = () => {},
  plans,
  currencies,
  isShowPlans,
}) => {
  const translation = useTranslation();

  const [isOpen, setIsOpen] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [isShowBranchCount, setIsShowBranchCount] = useState(false);
  const [branchCount, setBranchCount] = useState(null);
  const [lang, setLang] = useState("en");
  const [loading, setLoading] = useState(false);
  const [planData, setPlanData] = useState({});

  const { setBranchRequestsUnseenCount } = useStore();

  const openModal = (branch, type) => {
    const text =
      type === CANCELED
        ? `${translation.want_to_reject}`
        : `${translation.want_to_accept}`;
    const status = type ?? CONFIRMED;
    const data = {
      text,
      branch: {
        branchId: branch?.id,
        status,
      },
    };
    setSelectedBranch(data);
    setIsOpen(true);
  };

  const closeModal = () => {
    setSelectedBranch(null);
    setIsOpen(false);
    setIsShowBranchCount(false);
  };

  const statusAction = async (e) => {    
    e.preventDefault();
    const { branch } = selectedBranch;
    setLoading(true);

    if (userSection) {
      if (branch.status === CANCELED) {
        return await Api.main
          .deActivateUser({ userId, lang })
          .then(async () => {
            return await Api.main.getUserDetails(userId).then(({ data }) => {
              setUserDetails(data);
            });
          })
          .finally(() => setLoading(true));
      }
      return await Api.main
        .activateUser({ userId, suggestedBranchCount: branchCount, lang, planData })
        .then(async () => {
          return await Api.main.getUserDetails(userId).then(({ data }) => {
            setUserDetails(data);
          });
        })
        .finally(() => setLoading(true));
    }

    await Api.main
      .setBranchStatus({ ...branch, suggestedBranchCount: +branchCount })
      .then(() => {
        setSelectedBranch(null);
        setIsOpen(false);
        refresh();
      })
      .finally(() => {
        setSelectedBranch(null);
        setIsOpen(false);
        setLoading(false);
        Api.main
          .getBranchesUnseenCount()
          .then((res) => setBranchRequestsUnseenCount(res?.count ?? 0));
      });
  };

  const getPlanData = (planId) => {
    const plan = plans.find((p) => p.id === planId);
    const price = plan?.prices?.[0];
    const currency = currencies?.find((c) => c.code === price?.currency);

    const data = {
      plan_id: plan?.id,
      plan_type: price?.billing_period || "monthly",
      price: price?.price || 0,
      currency: currency?.id,
      trial_period_days: plan?.settings?.trial_period_days || 0,
      unlimited_items: plan?.settings?.unlimited_items || 0,
      max_inventory_items: plan?.settings?.max_inventory_items || 0,
    };
    return data;    
  }

  const handleChangePlanData = (field, value) => {
    if(field === 'plan_id') {
      const planData = getPlanData(value);
      setPlanData({...planData});
      return;
    }
    setPlanData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (!isOpen) {
      setPlanData({});
    } else {
      if(plans && currencies) {
        const planData = getPlanData(plans[0]?.id);
        setPlanData({...planData});
      }
    }
  }, [isOpen, plans, currencies]);
  
  return (
    <>
      <div className="font-size-sm align-box-row">
        <Button
          variant="contained"
          type="button"
          onClick={() => openModal(item, "canceled")}
          className="mr-2 button-1"
        >
          {translation.reject}
        </Button>
        <Button
          color="secondary"
          type="button"
          onClick={() => {
            setIsShowBranchCount(true);
            openModal(item);
            setBranchCount(item?.branch_count || item?.branches_count);
          }}
          className="button-2"
          variant="contained"
        >
          {translation.accept}
        </Button>
      </div>
      <AcceptUserModal
        isOpen={isOpen}
        close={closeModal}
        accept={statusAction}
        text={selectedBranch?.text}
        isShowBranchCount={isShowBranchCount}
        isShowLanguage
        setLang={setLang}
        lang={lang}
        branchCount={branchCount}
        setBranchCount={setBranchCount}
        loading={loading}
        plans={plans}
        currencies={currencies}
        handleChangePlanData={handleChangePlanData}
        planData={planData}
        isShowPlans={isShowPlans}
      />
    </>
  );
};
